export default () => ({
  show: false,
  loading: false,
  checkout: false,
  multipleProducts: null,
  error: false,
  showLoading: false,

  notice(productImage, productTitle, target, variant) {
    this.show = true;

    productImage &&
      this.setContent(productImage, productTitle, target, variant);

    setTimeout(() => {
      this.show = false;
    }, 4000);
    this.setTop();
  },
  showCart() {
    this.show = false;
    this.$dispatch("cart-toggle");
  },

  setTop() {
    var el = document
      .getElementById("shopify-section-usp-bar")
      ?.getBoundingClientRect();

    const spacing = el && Math.max(0, el.height + el.top) + 40;

    this.$refs.cartNotice &&
      (this.$refs.cartNotice.style.top = `${spacing || 40}px`);
  },

  setContent(productImage, productTitle, target, variant) {
    productImage &&
      (this.$refs.cartNoticeImage.innerHTML = ` <img
    src="${productImage}"
    alt=""
    class="absolute inset-0 w-full h-full object-cover"
    fetchpriority="high"
    loading="eager"
  >`);

    productTitle && (this.$refs.cartNoticeTitle.textContent = productTitle);

    const priceInput =
      target && target.querySelector('input[name="properties[_actualprice]"]');
    const price = priceInput && priceInput.value / 100;

    const curencyInput =
      target && target.querySelector('input[name="properties[_currency]"]');
    const curency = curencyInput && curencyInput.value;

    if (price && curency) {
      this.$refs.cartNoticePrice.textContent = price;
      this.$refs.cartNoticeCurrency.textContent = curency;
    }
    variant && (this.$refs.cartNoticeVariant.textContent = variant && variant);
  },
});
